import { Box, ButtonBase, Typography, createStyles, lighten, makeStyles } from '@material-ui/core';
import cn from 'classnames';
import * as React from 'react';
import { TranquiTheme } from '../App/theme';

interface DebtNegDetailsSelectItemProps {
  title: any,
  subtitle?: string,
  selected?: boolean,
  onClick?: () => void,
  className?: string;
  dataTest?: string;
}

const DebtNegDetailsSelectItem: React.FC<DebtNegDetailsSelectItemProps> = (props) => {
  const { className, title, subtitle, selected, onClick, dataTest } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <ButtonBase
      data-test={dataTest}
      className={cn(className, classes.item)}
      onClick={onClick}
      sx={{ px: 1 }}
      component={Box}
    >
      <Box className={cn(classes.wrapper, 'wrapper', selected && classes.selected)}>
        <Box className={classes.itemInner} sx={{ py: 2 }}>
          <Typography className={classes.title}><strong>{title}</strong></Typography>
          {subtitle
          && <Typography className={classes.subtitle}><small>{subtitle}</small></Typography>}
        </Box>
      </Box>
    </ButtonBase>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  item: {
    textAlign: 'center',
    transition: 'all .3s ease',
    position: 'relative',
    display: 'flex',
    alignSelf: 'flex-end',
    boxShadow: theme.shadows[4],
  },
  wrapper: {
    backgroundColor: '#ffffff',
    borderRadius: '5px',
    border: '1px solid transparent',
    inlineSize: '100%',
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    blockSize: `${theme.spacing(8)}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  selected: {
    borderColor: theme.palette.primary.main,
    borderWidth: '2px',
    backgroundColor: `${lighten(theme.palette.primary.light, 0.85)}`,
    padding: theme.spacing(1),
  },
  itemInner: {
    padding: theme.spacing(1),
  },
  title: {
    color: theme.palette.indigo.main,
  },
  subtitle: {
    color: theme.palette.text3.main,
  },
  icon: {
    position: 'absolute',
    top: 5,
    right: 5,
    color: theme.palette.text5.main,
  },
  iconChecked: {
    color: theme.palette.primary.main,
  },
}));

export default DebtNegDetailsSelectItem;
